import styled from 'styled-components';

// Faixa de atraso, no cabecalho do TableWrapper ao lado da busca.
export const FiltroBarra = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`;

export const FiltroLabel = styled.span.attrs({})`
  font-size: 12px;
  text-transform: uppercase;
  color: #718096;
  white-space: nowrap;
`;

export const FiltroCampo = styled.div.attrs({})`
  width: 90px;
`;

export const FiltroSeparador = styled.span.attrs({})`
  font-size: 13px;
  color: #718096;
`;
